import { FormValues, RequestFieldsValues } from "../types"
import { isString } from "lodash"

export const defaultInputs = {
  "Valuation Date": "2019-12-31",
  "Maturity Date": "2025-12-31",
  Coupon: "3.7",
  "Coupon Frequency": "",
  "Redemption Amount": "100",
  Spread: "0.1",
}

export const formatRequestData = (inputs: RequestFieldsValues) => {
  return {
    request_data: {
      inputs,
    },
    request_meta: {
      version_id: "dfecad4d-d40e-4b4e-8d0e-2c9f5ab33c3d", // TODO update this version_id from spark
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
      compiler_type: "NodeGen",
    },
  }
}

export const prepareEditableJsonData = (withCouponFrequence?: boolean) => {
  return {
    request_data: {
      inputs: {
        ...defaultInputs,
        "Coupon Frequency": withCouponFrequence ? "Monthly" : defaultInputs["Coupon Frequency"],
      },
    },
    request_meta: {
      version_id: "dfecad4d-d40e-4b4e-8d0e-2c9f5ab33c3d",
      call_purpose: "Spark - API Tester",
      source_system: "SPARK",
      correlation_id: "",
      requested_output: null,
      service_category: "",
      compiler_type: "NodeGen",
    },
  }
}

export const formatFormValues = (values: FormValues) => {
  return {
    "Valuation Date": String(values["Valuation Date"]),
    "Maturity Date": String(values["Maturity Date"]),
    Coupon: (isString(values.Coupon) ? Number(values.Coupon.replaceAll("%", "")) : values.Coupon) / 100,
    "Coupon Frequency": values["Coupon Frequency"],
    "Redemption Amount": Number(values["Redemption Amount"]),
    Spread: (isString(values.Spread) ? Number(values.Spread.replaceAll("%", "")) : values.Spread) / 100,
  }
}

export const prepareFormValuesFromJson = (editableModelData: any) => {
  return {
    "Valuation Date": editableModelData.request_data.inputs["Valuation Date"],
    "Maturity Date": editableModelData.request_data.inputs["Maturity Date"],
    Coupon: editableModelData.request_data.inputs.Coupon,
    "Coupon Frequency": editableModelData.request_data.inputs["Coupon Frequency"],
    "Redemption Amount": editableModelData.request_data.inputs["Redemption Amount"],
    Spread: editableModelData.request_data.inputs.Spread,
  }
}

